import { axiosWalletRequest, METHOD } from '../api/Requests';

export const getLast = async () => {
    const { data } = await axiosWalletRequest(`Relacionamento/ObterUltimoRelacionamentoAgendaPorData`, METHOD.GET);
    if (data) return new Date(data.Data);
    return null;
}

export const getFirst = async () => {
    const { data } = await axiosWalletRequest(`Relacionamento/ObterPrimeiroRelacionamentoAgendaPorData`, METHOD.GET);
    if (data) return new Date(data.Data);
    return null;
}

export const excludeRelationshipSchedule = (id) => axiosWalletRequest(`Relacionamento/ExcluirRelacionamentoAgenda/${id}`, METHOD.DELETE);

export const updateRelationshipSchedule = (body, id) => axiosWalletRequest(`Relacionamento/AtualizarRelacionamentoAgenda/${id}`, METHOD.PUT, body);

export const getScheduleByDate = (dateInverval) => axiosWalletRequest('Relacionamento/FiltrarRelacionamentoAgenda', METHOD.POST, dateInverval);